export const presence = (value) => (value ? undefined : "Required");

export const presenceMultiSelect = (value) =>
  value && value.length > 0 ? undefined : "Required";

export const phoneValidate = (value) =>
  value && !/^[0-9\(\) +-]*$/im.test(value) ? "Invalid phone number" : undefined;
